export const coolors = 'd00000-ffba08-3f88c5-032b43-136f63-73a580-e8e9eb-313638-331832-c6d8d3-30bced-303036-fffaff-fc5130-8cd790-b1740f-1f2041-4b3f72-ffc857-119da4-19647e-ccc9dc-ac3931-436436-c84c09-92b4f4-afd2e9-345995-fff689-a4243b-5b7553-345511-47a025-f75c03-340068-000505-afd2e9-345995-fff689-a4243b-5b7553-345511-47a025-f75c03-340068-050401-9e788f-ef6351-f38375-000505'.split('-').map(v => `#${v}`);
export function hashCode(str: string) {
    var hash = 0;
    if (str) {
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash &= hash; // Convert to 32bit integer
        }
    }
    return hash;
}
export function getHashNum(str: string, num: number) {
    return Math.abs(hashCode(str) % num);
}
export function getHashColor(str: string) {
    if (str === 'FLOW_OF_CONTROL_OUT') {
        str = 'FLOW_OF_CONTROL_IN';
    }
    let index = Math.abs(getHashNum(str, coolors.length));
    return coolors[index];
}